module.exports = __webpack_public_path__ + "static/media/secondary.ee9bdb5a.png";